import React, { useEffect } from 'react'
import { useCmsBlock, useCustomer } from 'lib/core/hooks'
import { useCheckoutSuccess } from 'lib/modules/checkout'
import { useListrakConversion } from 'modules/listrak'
import { useJustunoConversion } from 'modules/justuno'
import { Container, PrincipalWrapper, OrderSuccessContentWrapper } from './styled'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Link } from 'react-router-dom'
import { fetchCategoryList } from 'lib/core/data/blog/categoryList'
import { useDispatch } from 'react-redux'
import { NormalGrid } from 'app/sofia/scenes/Blog/components/PostsGrid/components/Styled'
import { Container as Posts } from 'app/sofia/scenes/Blog/components/PostTile/components/Container'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

export const Success = () => {
  const staticBlockID = CMS_BLOCK.FACEBOOK_COMMUNITY
  const featuredPostsId = CMS_BLOCK.SUCCESS_FEATURED_POSTS
  const orderSuccessContentId = CMS_BLOCK.ORDER_SUCCESS_CONTENT_SG
  const dispatch = useDispatch()
  const { orderId } = useCheckoutSuccess()
  useJustunoConversion(orderId)
  const { renderTrackingPixel } = useListrakConversion(orderId)
  const PostsContainer = NormalGrid
  const communityBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  }) as CmsBlockData

  const featuredBlock = useCmsBlock({
    id: featuredPostsId,
    isLazy: false
  }) as CmsBlockData

  const orderSuccessContentBlock = useCmsBlock({
    id: orderSuccessContentId,
    isLazy: false
  }) as CmsBlockData

  const { isLoggedIn } = useCustomer()

  const orderUrl = isLoggedIn
    ? '/customer/account/orders'
    : '/customer/account/login'

  useEffect(() => {
    dispatch(fetchCategoryList())
  }, [dispatch])

  return (
    <Container>
      {renderTrackingSuccess()}
      {renderTrackingPixel()}
      <h1>Order Received</h1>
      <div className='confirmation'>
        <h3>Confirmation</h3>
      </div>
      <PrincipalWrapper>
        <div className='orderDetails'>
          <h2>Thank you! We'll take it from here!</h2>
          <p>
            <Link to={orderUrl}>View Order</Link>
          </p>
          <p>
            <Link to='/bladder-control'>Continue Shopping</Link>
          </p>
        </div>
        {communityBlock.isSuccess && (
          <div
            dangerouslySetInnerHTML={{
              __html: communityBlock?.content ?? ''
            }}
          />
        )}
      </PrincipalWrapper>
      {featuredBlock.isSuccess && (
        <PostsContainer className='posts'>
          <h2>
            Stay awhile, here are a couple of articles our community is loving.
          </h2>
          <div className='posts-grid'>
            <Posts
              dangerouslySetInnerHTML={{
                __html: featuredBlock?.content ?? ''
              }}
            />
          </div>
        </PostsContainer>
      )}
      {orderSuccessContentBlock.isSuccess && (
        <OrderSuccessContentWrapper
          dangerouslySetInnerHTML={{
            __html: orderSuccessContentBlock?.content ?? ''
          }}
        />
      )}
    </Container>
  )
}

const renderTrackingSuccess = () => {
  return <iframe src='https://f.performlt.com/aff_l?offer_id=13997' title='Success tracking pixel' scrolling='no' frameBorder='0' width='1' height='1' />
}
